var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { staticClass: "d-block" }, [
        _vm._v("Mögliche erzeugbare Dateianhänge"),
      ]),
      _vm._v(" "),
      _c("b-table", {
        ref: "documentTable",
        attrs: { fields: _vm.attachmentFields, items: _vm.preparedAttachments },
        scopedSlots: _vm._u([
          {
            key: "cell(selected)",
            fn: function (rowData) {
              return [
                _c("b-form-checkbox", {
                  attrs: {
                    checked: rowData.item.checked,
                    value: rowData.item.name,
                  },
                  on: {
                    change: (checked) =>
                      _vm.handleCheckboxChange(rowData, checked),
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }